import { render, staticRenderFns } from "./RecurringRegistrationsList.vue?vue&type=template&id=3cbf94e1"
import script from "./RecurringRegistrationsList.vue?vue&type=script&lang=js"
export * from "./RecurringRegistrationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports